import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { Popover } from '@mui/material';
import React from 'react';
import { LayoutProps } from './model';

const COMPONENT_WIDTH = 354;

const Desktop: React.FC<React.PropsWithChildren<LayoutProps>> = ({ children, onClose, isOpen, target, absoluteTopPosition }) => {
  const theme = useTheme();

  return (
    <Popover
      anchorEl={target?.current}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      onClose={onClose}
      open={isOpen}
      slotProps={{
        paper: {
          sx: {
            top: absoluteTopPosition ? `${absoluteTopPosition}px!important` : undefined,
            width: COMPONENT_WIDTH,
            backgroundColor: theme.palette.background.default,
            boxShadow: '0px 11px 16px rgba(0, 0, 0, 0.13)',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomRightRadius: `${theme.borderRadius.medium}px`,
            borderBottomLeftRadius: `${theme.borderRadius.medium}px`,
            overflow: 'visible',
            zIndex: 50,
          },
        },
      }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      {children}
    </Popover>
  );
};

export default Desktop;
